import {
  activation,
  CURRENT_YEAR,
  setPeriod,
  setReport
} from "../../../ducks/reportActivation";


import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { beginLoading, endLoading } from "../../../ducks/loadingSpinner";
import { messagesReceived } from "../../../ducks/message";
import RespondentActivation from "./RespondentActivation";

const mapStateToProps = (state, ownProps) => {
  return {
    lectorates: ownProps.lectorates,
    currentYear: state.reportActivation[CURRENT_YEAR]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    actions: bindActionCreators(
      {
        setPeriod,
        setReport,
        activation,
        messagesReceived,
        beginLoading,
        endLoading
      },
      dispatch
    ),
    externalActions: {
      close: ownProps.close
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RespondentActivation);
